import React from "react";
import Car1 from "./Images/Illustration/about.1044506a3d3cb06c91b2.png";
import d1 from "./Images/Illustration/download (8).png";
import d2 from "./Images/Illustration/download (9).png";
import d3 from "./Images/Illustration/download (10).png";
import d4 from "./Images/Illustration/download (5).png";
import d5 from "./Images/Illustration/download (6).png";
import d6 from "./Images/Illustration/download (7).png";
import toyota from "./Images/Illustration/toyota-offer-2.861de085d1c782df9e9d.png";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import driver1 from "./Images/Illustration/driver-1.cc28e20ef89a3dd83430.jpg";
import driver2 from "./Images/Illustration/driver2.jpg";
import driver3 from "./Images/Illustration/driver-3.154de7902469bef24a47.jpg";
import driver4 from "./Images/Illustration/driver-4.c8e5ec8a940eb337ad54.jpg";

const Home = () => {
    return (
        <>
            <section className="container-fluid p-0">
                <section className="container-fluid hero">
                    <div className='row'>
                        <div className='col-12 my-auto text-white text-center py-5' >
                            <p className='pt-5'>for rent $70 per day</p>
                            <h2>Reserved Now & Get 50% Off</h2>
                            <a className="btn text-white" href="">Reserve Now!</a>
                        </div>
                    </div>
                </section>

                <section className="container-fluid about py-5">
                    <div className='row g-0'>
                        <div className='col-12 col-md-6'>
                            <h4 className="orange">About Us</h4>
                            <h2>Welcome To Gauto</h2>
                            <p>Since 1992 we have not only committed ourselves to delivering exceptional repair and maintenance service to the worldwide automotive owners.</p>
                            <ul>
                                <li><i className="fa-solid fa-square-check"></i>We are a trusted name</li>
                                <li><i className="fa-solid fa-square-check"></i>we deal in have all brands</li>
                                <li><i class="fa-solid fa-square-check"></i>have a larger stock of vehicles</li>
                                <li><i class="fa-solid fa-square-check"></i>we are at worldwide locations</li>
                            </ul>
                        </div>
                        <div className='col-12 col-md-6'>
                            <img src={Car1} className="img-fluid" alt="Image Not Found" />
                        </div>
                    </div>
                </section>
                {/* end of about */}

                <section className='container-fluid service py-5 service'>
                    <div className='row '>
                        <div className='col-12'>
                            <h4 className='orange'>See Our</h4>
                            <h2>Latest Service</h2>
                            <OwlCarousel className='owl-theme text-center' loop margin={10} nav>
                                <div className='item'>
                                    <img src={d1} />
                                    <h3>City Transfer</h3>
                                    <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                                </div>
                                <div className='item '>
                                    <img src={d2} />
                                    <h3>Air Transfer</h3>
                                    <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                                </div>
                                <div className='item'>
                                    <img src={d3} />
                                    <h3>Hospital Transfer</h3>
                                    <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                                </div>
                                <div className='item'>
                                    <img src={d4} />
                                    <h3>Wedding Ceremony</h3>
                                    <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                                </div>
                                <div className='item'>
                                    <img src={d5} />
                                    <h3>Whole city tour</h3>
                                    <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                                </div>
                                <div className='item'>
                                    <img src={d6} />
                                    <h3>Baggage Transport</h3>
                                    <p>Risus commodo maecenas accumsan lacus vel facilisis. Dorem ipsum dolor consectetur adipiscing elit.</p>
                                </div>

                            </OwlCarousel>;
                        </div>
                        <div className="row back1 text-white text-center justify-content-center">
                            <div className="col-12 col-md-6 py-5 bg-dark bg-opacity-75"> <img src={toyota} alt='Image Not Found' /></div>
                            <div className="col-12 col-md-6 py-5">
                                <h3>Do You Want To Earn With Us? So Don't be Late.</h3>
                                <a className="btn text-white" href="#">Become a Driver</a>
                            </div>
                        </div>



                    </div>
                </section>
                <section className="container-fluid">

                    <div className="row driver text-center py-5 d-flex justify-content-center">
                        <h4 className="orange">Experts</h4>
                        <h2 className="pb-5">Our Members</h2>
                        <div className="col-12 col-md-6 col-lg-3"><img src={driver1} className="img-fluid" alt="image not found" /><h3>Marco Ghaly</h3><p className="text-muted">4 Years Experience</p></div>
                        <div className="col-12 col-md-6 col-lg-3"><img src={driver2} className="img-fluid" alt="image not found" /><h3>Sheref Joe</h3><p className="text-muted">7 Years Experience</p></div>
                        <div className="col-12 col-md-6 col-lg-3"><img src={driver3} className="img-fluid" alt="image not found" /><h3>Arafa Lep</h3><p className="text-muted">3 Years Experience</p></div>
                        <div className="col-12 col-md-6 col-lg-3"><img src={driver4} className="img-fluid" alt="image not found" /><h3>Endly Kent</h3><p className="text-muted">4 Years Experience</p></div>
                        <div className="pt-5"><a className="btn col-2" href="#">More Members</a></div>
                    </div>

                </section>
                {/* end of service */}
            </section>
        </>

    );


};
export default Home;